import {
    EventEmitter, QueryList, ElementRef, SimpleChange,
    ChangeDetectorRef, IterableDiffers, KeyValueDiffers, OnInit,
    DoCheck, AfterContentInit, AfterViewInit, OnChanges, AfterContentChecked, OnDestroy
} from '@angular/core';

export { ContentChild, Type, forwardRef } from '@angular/core';

export let /** @type {?} */ currentTemplateElement: any;



export interface IParentTag {
    tags: Array<any>;
}

export interface IChildChange {
    index: number;
    change: any;
}

export interface IChangeSet {
    [key: string]: Array<IChildChange>;
}

let /** @type {?} */ firstVal = {};
/**
 * Internal Helpers
 */
export class Utils {
/**
 * @param {?} obj
 * @return {?}
 */
static IterateAndGetChanges(obj: IParentTag): IChangeSet {
        if (ej.isNullOrUndefined(obj.tags) || obj.tags.length === 0) {
            return null;
        }
        let /** @type {?} */ res: IChangeSet = {};
        for (let /** @type {?} */ i = 0, /** @type {?} */ tags = obj.tags; i < tags.length; i++) {
            let /** @type {?} */ tag = tags[i], /** @type {?} */ tagElement = ( /** @type {?} */((<any>obj)))['tag_' + tag.replace(/\./g, '_')];
            if (!ej.isNullOrUndefined(tagElement) && tagElement.hasChanges) {
                res[tag] = tagElement.getChangesAndReset();
            }
        }
        return res;
    }

}
export class BoldReportComponents<W, T> implements IParentTag, OnInit, AfterContentInit, DoCheck, AfterViewInit, OnChanges, AfterContentChecked, OnDestroy {
public model: T = /** @type {?} */(( <T>{}));
public widget: W;
    protected outputs: Array<string> = [];
    protected inputs: Array<string> = [];
    protected twoways: Array<string> = [];
    protected complexProperties: Array<string>;
    protected isEditor: boolean;
private firstCheck: boolean;
    ejIterable: any;
    ejKeyValueDif: any;
/**
 * @param {?} instance
 * @param {?} model
 * @param {?} event
 * @return {?}
 */
private static bindAndRaiseEvent(instance: any, model: any, event: string) {
        if (!event.startsWith('model.')) {// && instance[event]['observers'].length > 1) {
            let /** @type {?} */ originalEvt = event.startsWith('bold') ? event.substr(4) : event;
            model[originalEvt] = function (params: any) {
                instance[event + '_output']['emit'](params);
            };
        }
    }
/**
 * @param {?} controlName
 * @param {?} el
 * @param {?} cdRef
 * @param {?} tags
 * @param {?} ejIterableDiffers
 * @param {?} _ejKeyValueDiffers
 */
constructor(protected controlName: string, protected el: ElementRef, protected cdRef: ChangeDetectorRef,
public tags: Array<string>,
private ejIterableDiffers: IterableDiffers,
private _ejKeyValueDiffers: KeyValueDiffers) {
        //        this.__shadow = this.dom.getShadowRoot(this.el.nativeElement);
        this.firstCheck = true;
        this.ejIterable = this.ejIterableDiffers.find([]).create(null);
        this.ejKeyValueDif = _ejKeyValueDiffers.find([]).create();
    }
/**
 * @param {?} twoways
 * @return {?}
 */
protected createTwoways(twoways: Array<string>) {
        if (!twoways) { return; }
        let /** @type {?} */ model = this.model;
        for (let /** @type {?} */ i = 0; i < twoways.length; i++) {
            let /** @type {?} */ element = twoways[i].replace(/\_/g, '.');
            ej.createObject(element + 'Change', ( /** @type {?} */((<any>this)))[twoways[i] + '_twoChange'], model);
            ej.createObject(element, this.addTwoways(element), model);
        }
    }
/**
 * @param {?} prop
 * @return {?}
 */
protected addTwoways(prop: string): Function {
        let /** @type {?} */ model = this.model, /** @type {?} */ value = firstVal; // , originalProp = prop.replace(/-/g, '.');
        return function (newVal: any, isApp: boolean) {
            if (value === firstVal) {
                value = ej.getObject(prop + '_two', model);
                if (value === undefined) {
                    value = ej.getObject(prop, this === undefined || this.defaults === undefined ? {} : this.defaults);
                }
            }
            if (newVal === undefined) {
                return value;
            }
            if (value === newVal) { return; }
            value = newVal;
            if (!isApp) {
                ej.createObject(prop + '_two', newVal, model);
                ej.getObject(prop + 'Change', model).emit(newVal);
            }
        };
    }
/**
 * @return {?}
 */
ngOnInit() {
        for (let /** @type {?} */ key in this) {
            if (key.indexOf('_input') != -1)
                this.inputs.push(key);
            if (key.indexOf('_output') != -1)
                this.outputs.push(key);
            if (key.indexOf('_two') != -1 && key.indexOf('_twoChange') == -1)
                this.twoways.push(key.replace('_two', ''));
        }
        if (ej.isNullOrUndefined(( /** @type {?} */((<any>this)))['options'])) {
            this.createTwoways(this.twoways);
        }
    }
/**
 * @return {?}
 */
ngAfterContentInit() {
        this.firstCheck = false;

        let /** @type {?} */ model = this.model, /** @type {?} */ events = this.outputs;
        if (events) {
            for (let /** @type {?} */ i = 0; i < events.length; i++) {
                let /** @type {?} */ event = events[i].replace('_output', '');
                BoldReportComponents.bindAndRaiseEvent(this, model, event);
            }
        }
        if (ej.isNullOrUndefined(( /** @type {?} */((<any>this)))['options'])) {
            for (let /** @type {?} */ i = 0; i < this.tags.length; i++) {
                let /** @type {?} */ element = this.tags[i], /** @type {?} */ item = ( /** @type {?} */((<any>this)))['tag_' + element.replace(/\./g, '_')];
                if (!ej.isNullOrUndefined(item)) {
                    ej.createObject(element, item.getList(), this.model);
                }
            }

            for (let /** @type {?} */ i = 0; i < this.inputs.length; i++) {
                let /** @type {?} */ property = this.inputs[i];
                let /** @type {?} */ modelProperty = this.inputs[i].replace('_input', '');
                if (( /** @type {?} */((<any>this)))[property] != null) {
                    if (modelProperty.indexOf('_') == -1) {
                        if (( /** @type {?} */((<any>this.model)))[modelProperty]) {
                            $.extend(true, ( /** @type {?} */((<any>this.model)))[modelProperty], ( /** @type {?} */((<any>this)))[property]);
                        } else {
                            ( /** @type {?} */((<any>this.model)))[modelProperty] = ( /** @type {?} */((<any>this)))[property];
                        }
                    } else if (modelProperty.indexOf('_two') == -1) {
                        let /** @type {?} */ tempObj: any = {};
                        let /** @type {?} */ key = modelProperty.replace(/\_/g, '.');
                        ej.createObject(key, ( /** @type {?} */((<any>this)))[property], tempObj);
                        let /** @type {?} */ rootProp = key.split('.')[0];
                        if (( /** @type {?} */((<any>this.model)))[rootProp] == undefined)
                            ( /** @type {?} */((<any>this.model)))[rootProp] = {};
                        $.extend(true, ( /** @type {?} */((<any>this.model)))[rootProp], tempObj[rootProp]);
                    }
                }
            }
            for (let /** @type {?} */ i = 0; i < this.twoways.length; i++) {
                let /** @type {?} */ twoway = this.twoways[i];
                let /** @type {?} */ twowayProperty = twoway + '_two';
                if (( /** @type {?} */((<any>this)))[twowayProperty] != null) {
                    if (twoway.indexOf('_') == -1) {
                        ( /** @type {?} */((<any>this.model)))[twowayProperty] = ( /** @type {?} */((<any>this)))[twowayProperty];
                    } else {
                        let /** @type {?} */ tempObj: any = {};
                        let /** @type {?} */ key = twoway.replace(/\_/g, '.') + '_two';
                        ej.createObject(key, ( /** @type {?} */((<any>this)))[twowayProperty], tempObj);
                        let /** @type {?} */ rootProp = twowayProperty.split('_')[0];
                        $.extend(true, ( /** @type {?} */((<any>this.model)))[rootProp], tempObj[rootProp]);
                    }
                }
            }
        }
        else
            this.model = jQuery.extend(this.model, ( /** @type {?} */((<any>this)))['options']);

    }
/**
 * @return {?}
 */
ngDoCheck() {
        if (ej.isNullOrUndefined(( /** @type {?} */((<any>this)))['options'])) {
            this.twoways.forEach(element => {
                if (( /** @type {?} */((<any>this)))[element + '_two'] instanceof Array) {
                    let /** @type {?} */ changes = this.ejIterable.diff(( /** @type {?} */((<any>this)))[element + '_two']);
                    if (changes) {
                        let /** @type {?} */ ngChanges = {};
                        if (this.widget != undefined) {
                            ngChanges = this.getTwowayChanges(changes.collection, ngChanges, element.replace(/\_/g, '.'));
                            ej.createObject(element.replace(/\_/g, '.') + '.two', changes.collection, ngChanges);
                            ( /** @type {?} */((<any>this.widget)))['setModel'](ngChanges, $.isPlainObject(ngChanges));
                        }
                    }
                }
            });

        }
        else {
            let /** @type {?} */ changes = this.ejKeyValueDif.diff(( /** @type {?} */((<any>this)))['options']);
            if (changes) {
                if (this.widget != undefined) {
                    var /** @type {?} */ ngchanges = {};
                    changes.forEachChangedItem((changedprop: any) => {
                        ej.createObject(changedprop.key, changedprop.currentValue, ngchanges);
                    });
                    ( /** @type {?} */((<any>this.widget)))['setModel'](ngchanges, $.isPlainObject(ngchanges));
                }
            }
        }
    }
/**
 * @return {?}
 */
ngAfterViewInit() {
        let /** @type {?} */ nativeElement = this.isEditor ? $(this.el.nativeElement.children) : $(this.el.nativeElement);
        let /** @type {?} */ controlName: string = this.lowerCaseFirstLetter(this.controlName);
        this.widget = ( /** @type {?} */(($(nativeElement) as any)))[controlName](this.model)[controlName]('instance');
    }
/**
 * @param {?} string
 * @return {?}
 */
lowerCaseFirstLetter(string: string) {
        return string[0].toLowerCase() + string.slice(1);
    }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: { [key: string]: SimpleChange }) {
        if (this.firstCheck) { return; }
        let /** @type {?} */ ngChanges = {};
        if (ej.isNullOrUndefined(( /** @type {?} */((<any>this)))['options'])) {
            for (let /** @type {?} */ key in changes) {
                let /** @type {?} */ element = changes[key];
                if (element.previousValue === element.currentValue) {
                    break;
                }
                key = key.replace('_input', '').replace(/\_/g, '.');
                if (key.endsWith('.two')) {
                    let /** @type {?} */ oKey = key.replace('.two', '');
                    ngChanges = this.getTwowayChanges(element.currentValue, ngChanges, oKey);
                }
                ej.createObject(key, element.currentValue, ngChanges);
            }

            ( /** @type {?} */((<any>this.widget)))['setModel'](ngChanges, $.isPlainObject(ngChanges));
        }
    }
/**
 * @param {?} value
 * @param {?} ngChanges
 * @param {?} prop
 * @return {?}
 */
getTwowayChanges(value: any, ngChanges: any, prop: string) {
        let /** @type {?} */ valFn = ej.getObject(prop, ( /** @type {?} */((<any>this.widget)))['model']);
        valFn(value, true);
        ej.createObject(prop, valFn, ngChanges);
        return ngChanges;
    }
/**
 * @return {?}
 */
ngAfterContentChecked() {
        // TODO: ChangeDetection Third/Multi level
        let /** @type {?} */ changes: IChangeSet = Utils.IterateAndGetChanges(this);
        for (let /** @type {?} */ key in changes) {
            if (changes.hasOwnProperty(key)) {
                let /** @type {?} */ element = changes[key];
                ( /** @type {?} */((<any>this.widget)))['_' + key](element);
            }
        }
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        ( /** @type {?} */((<any>this.widget)))['destroy']();
    }
}

function BoldReportComponents_tsickle_Closure_declarations() {
/** @type {?} */
BoldReportComponents.prototype.model;
/** @type {?} */
BoldReportComponents.prototype.widget;
/** @type {?} */
BoldReportComponents.prototype.outputs;
/** @type {?} */
BoldReportComponents.prototype.inputs;
/** @type {?} */
BoldReportComponents.prototype.twoways;
/** @type {?} */
BoldReportComponents.prototype.complexProperties;
/** @type {?} */
BoldReportComponents.prototype.isEditor;
/** @type {?} */
BoldReportComponents.prototype.firstCheck;
/** @type {?} */
BoldReportComponents.prototype.ejIterable;
/** @type {?} */
BoldReportComponents.prototype.ejKeyValueDif;
/** @type {?} */
BoldReportComponents.prototype.controlName;
/** @type {?} */
BoldReportComponents.prototype.el;
/** @type {?} */
BoldReportComponents.prototype.cdRef;
/** @type {?} */
BoldReportComponents.prototype.tags;
/** @type {?} */
BoldReportComponents.prototype.ejIterableDiffers;
/** @type {?} */
BoldReportComponents.prototype._ejKeyValueDiffers;
}

export class ComplexTagElement implements OnInit, OnChanges, AfterContentChecked {
    recentChanges: any;
    hasChanges: boolean;
    firstChange: boolean;
    index: number;
    valueChange: EventEmitter<any> = new EventEmitter();
    protected complexProperties: Array<string>;
    property: string;
    parent: BoldReportComponents<any, any>;
    complexes: Array<string> = [];
/**
 * @param {?} tags
 */
constructor(public tags: Array<string>) {
        this.hasChanges = false;
        this.firstChange = true;

        Object.defineProperty(this, 'parent', {
            enumerable: false,
            writable: true,
            value: null
        });
        currentTemplateElement = this;
    }
/**
 * @return {?}
 */
ngOnInit() {
        this.firstChange = false;
        for (let /** @type {?} */ key in this) {
            if (key.indexOf('_') != -1 && key.indexOf('tag_') == -1)
                this.complexes.push(key);
        }
        for (let /** @type {?} */ i = 0; i < this.complexes.length; i++) {
            let /** @type {?} */ property = this.complexes[i];
            if (property.indexOf('_') != -1) {
                let /** @type {?} */ tempObj: any = {};
                let /** @type {?} */ key = property.replace(/\_/g, '.');
                ej.createObject(key, ( /** @type {?} */((<any>this)))[property], tempObj);
                let /** @type {?} */ rootProp = key.split('.')[0];
                if (( /** @type {?} */((<any>this)))[rootProp] == undefined) ( /** @type {?} */((<any>this)))[rootProp] = {};
                $.extend(true, ( /** @type {?} */((<any>this)))[rootProp], tempObj[rootProp]);
            }
        }
    }
/**
 * @return {?}
 */
ensureCleanObject() {
        let /** @type {?} */ tags = this.tags;
        for (let /** @type {?} */ i = 0; i < tags.length; i++) {
            let /** @type {?} */ element = tags[i], /** @type {?} */ tagElement = ( /** @type {?} */((<any>this)))['tag_' + element.replace(/\./g, '_')];

            if (i === 0 && ( /** @type {?} */((<any>this)))[element]) { return; }
            if (ej.isNullOrUndefined(tagElement)) { continue; }

            ej.createObject(element, tagElement.getList(), this);
        }
    }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: { [key: string]: SimpleChange }) {
        if (this.firstChange) { return; }
        this.recentChanges = changes;
        this.hasChanges = true;
    }
/**
 * @return {?}
 */
getChangesAndReset() {
        if (this.hasChanges === false) { return; }

        let /** @type {?} */ changes = this.recentChanges || {};
        let /** @type {?} */ contentChanges = Utils.IterateAndGetChanges(this);
        if (!$.isEmptyObject(contentChanges)) {
            for (let /** @type {?} */ key in contentChanges) {
                if (contentChanges.hasOwnProperty(key)) {
                    let /** @type {?} */ element = contentChanges[key];
                    // this.el.nativeElement.
                    if (!ej.isNullOrUndefined(this.parent.widget['_' + this.property.replace(/\./g, '_') + '_' + key]))
                        this.parent.widget['_' + this.property.replace(/\./g, '_') + '_' + key](element);
                }
            }
        }

        this.hasChanges = false;
        return changes;
    }
/**
 * @return {?}
 */
ngAfterContentChecked() {
        let /** @type {?} */ tags = this.tags;
        for (let /** @type {?} */ i = 0, /** @type {?} */ len = tags.length; i < len; i++) {
            let /** @type {?} */ element = tags[i], /** @type {?} */ tagElement = ( /** @type {?} */((<any>this)))['tag_' + element.replace(/\./g, '_')];
            if (tagElement && tagElement.hasChanges) {
                this.hasChanges = true;
            }
        }
    }
}

function ComplexTagElement_tsickle_Closure_declarations() {
/** @type {?} */
ComplexTagElement.prototype.recentChanges;
/** @type {?} */
ComplexTagElement.prototype.hasChanges;
/** @type {?} */
ComplexTagElement.prototype.firstChange;
/** @type {?} */
ComplexTagElement.prototype.index;
/** @type {?} */
ComplexTagElement.prototype.valueChange;
/** @type {?} */
ComplexTagElement.prototype.complexProperties;
/** @type {?} */
ComplexTagElement.prototype.property;
/** @type {?} */
ComplexTagElement.prototype.parent;
/** @type {?} */
ComplexTagElement.prototype.complexes;
/** @type {?} */
ComplexTagElement.prototype.tags;
}

export class ArrayTagElement<T extends ComplexTagElement> implements AfterContentInit, AfterContentChecked {
    list: Array<T>;
    children: QueryList<T>;
    recentChanges: Array<IChildChange>;
    hasChanges: boolean;
/**
 * @param {?} propertyName
 */
constructor(public propertyName: string) {
        this.hasChanges = false;
    }
/**
 * @return {?}
 */
ngAfterContentInit() {
        let /** @type {?} */ index = 0;
        this.list = this.children.map((child) => {
            child.index = index++;
            child.property = this.propertyName;
            return child;
        });
    }
/**
 * @return {?}
 */
getList() {
        let /** @type {?} */ list = this.list;
        for (let /** @type {?} */ i = 0; i < list.length; i++) {
            list[i].ensureCleanObject();
        }
        return list;
    }
/**
 * @return {?}
 */
getChangesAndReset(): Array<IChildChange> {
        this.hasChanges = false;
        return this.recentChanges;
    }
/**
 * @return {?}
 */
ngAfterContentChecked(): void {
        let /** @type {?} */ changes = {}, /** @type {?} */ res: Array<IChildChange> = ( /** @type {?} */((<any>changes)))[this.propertyName] = [], /** @type {?} */ childChange: any;

        for (let /** @type {?} */ i = 0, /** @type {?} */ list = this.list; i < list.length; i++) {
            let /** @type {?} */ child = list[i];
            if (child.hasChanges) {
                childChange = child.getChangesAndReset();
                if (!ej.isNullOrUndefined(childChange)) {
                    res.push( /** @type {?} */((<IChildChange>{
                        index: child.index,
                        change: childChange
                    })));
                }
            }
        }

        if (res.length > 0) {
            this.recentChanges = res;
            this.hasChanges = true;
        }
    }
}

function ArrayTagElement_tsickle_Closure_declarations() {
/** @type {?} */
ArrayTagElement.prototype.list;
/** @type {?} */
ArrayTagElement.prototype.children;
/** @type {?} */
ArrayTagElement.prototype.recentChanges;
/** @type {?} */
ArrayTagElement.prototype.hasChanges;
/** @type {?} */
ArrayTagElement.prototype.propertyName;
}

